import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModel as ApiModels, WintUtilsWebApi } from "wint-api-client/dist/types";
import { AgreementFormTypes } from "models/formTypes";
import useAPIClientHelper from "./useAPIClientHelper";
import { CompanyService } from "services";

function useAgreementService() {
  const { apiClientInstance } = useAPIClientHelper();

  const hasAgreementPermissions = () => {
    return CompanyService.hasRelation(AuthEnums.PersonCompanyRelationType.Agreement);
  };
  const getById = (id: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .AgreementClient.GetById(id)
      .then((res) => res.data);
  };
  const filter = (filter: ApiModels.AgreementFilter) => {
    return apiClientInstance(AuthEnums.AuthType.Company).AgreementClient.GetByFilter(filter);
  };
  const update = (agreement: ApiModels.AgreementPost, id: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company, { showErrors: true }).AgreementClient.Update(agreement, id);
  };
  const create = (agreement: ApiModels.AgreementPost) => {
    return apiClientInstance(AuthEnums.AuthType.Company, { showErrors: true }).AgreementClient.Post(agreement);
  };
  const reportToAPIFilter = (
    formFilter?: AgreementFormTypes.Filter
  ): Omit<ApiModels.AgreementFilter, keyof WintUtilsWebApi.Filter> => {
    return {
      start: formFilter?.agreementPeriod?.start,
      end: formFilter?.agreementPeriod?.end,
      active: formFilter?.active,
      counterPart: formFilter?.counterPart,
      name: formFilter?.name,
      description: formFilter?.description,
      minMonthlyCost: formFilter?.monthlyCostPeriod?.lowest,
      maxMonthlyCost: formFilter?.monthlyCostPeriod?.highest,
      minTotalCost: formFilter?.totalCostPeriod?.lowest,
      maxTotalCost: formFilter?.totalCostPeriod?.highest,
    };
  };
  const reportFilter = (baseFilter: WintUtilsWebApi.Filter, formFilter?: AgreementFormTypes.Filter) => {
    return filter({
      ...baseFilter,
      ...reportToAPIFilter(formFilter),
    });
  };

  const getPdf = (id: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      responseType: "arraybuffer",
    } as any).IncomingInvoiceClient.GetPdf(id);
  };
  return {
    hasAgreementPermissions,
    getById,
    filter,
    update,
    create,
    reportToAPIFilter,
    reportFilter,
    getPdf,
  };
}

export default useAgreementService;
